import { gql } from '@apollo/client';

const PREPARE_SITE_INVITATIONS = gql`
  mutation PrepareSiteInvitations($input: PrepareSiteInvitationInput) {
    prepareSiteInvitations(input: $input) {
      alreadyExistingUsers
      comment
      companies {
        companyName
        publicCompanyId
      }
      siteId
      siteName
      userDataItems {
        companyName
        highlightedCompanyIds
        email
        status
        statusMessage
        selectedCompanyId
        knownUser
        userPaysForThemselves
        publicCompanyId
        siteRoleId
        siteRoleName
      }
    }
  }
`;

export default PREPARE_SITE_INVITATIONS;
